module.exports = __webpack_public_path__ + "static/media/arrow-down.51eac723.svg";